<script setup>
import { ref } from 'vue'
import { UUID } from '@/modules/util/uuid'

const props = defineProps([
	'modelValue', 
	'style', 
	'size', 
	'variant', 
	'color', 
	'prependIcon', 
	'appendIcon', 
	'multiple',
])
const emit = defineEmits(['update:modelValue'])

const id = ref(new UUID().get())
const input = ref(null)

const open = () => {
	input.value.click()
}

const onChange = () => {
	const files = input.value.files
    
	if (!files.length) {
		emit('update:modelValue', props.multiple ? [] : null)
		return
	}

	if (props.multiple) {
		emit('update:modelValue', Array.from(files))
	} else {
		emit('update:modelValue', files[0])
	}
}
</script>

<template>
<v-btn
	:class="$attrs.class"
	:style="style"
	:variant="variant"
	:color="color"
	:size="size"
	:prepend-icon="props.prependIcon"
	:append-icon="props.appendIcon"
	@click="open"
>
	<slot>{{ label }}</slot>
</v-btn>

<input
	v-bind="$attrs"
	:id="id"
	ref="input"
	type="file"
	hidden
	@change="onChange"
>
</template>

<style lang="scss" scoped>

</style>@/modules/util/uuid